import { decodeImage, type ImageAsset, type ViewModelInstance } from '@rive-app/react-canvas';

// A slot key (bind_option_1_gc) lives either flat on the main view model or nested in a `bind` view model
// (bind/option_1_gc), depending on how the file was authored.
export function slotPaths(key: string): string[] {
  return key.startsWith('bind_') ? [key, `bind/${key.slice('bind_'.length)}`] : [key];
}

// bind_asset_{n}: a Rive image property whose value (from the admin's xlsx) is an image URL.
const ASSET_SLOT_PATTERN = /^bind_asset_[1-9]\d*$/;

export function isRiveAssetSlot(path: string): boolean {
  return ASSET_SLOT_PATTERN.test(path);
}

async function fetchRiveImage(url: string) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Rive asset failed to load (${res.status}): ${url}`);
  return decodeImage(new Uint8Array(await res.arrayBuffer()));
}

// A file image asset named bind_asset_{n} (Rive's Assets panel), swapped while the file loads.
export async function replaceRiveFileAsset(asset: ImageAsset, url: string): Promise<void> {
  const image = await fetchRiveImage(url);
  asset.setRenderImage(image);
  image.unref();
}

export async function applyRiveAssetImage(
  viewModelInstance: ViewModelInstance,
  path: string,
  url: string,
  isStale: () => boolean,
): Promise<void> {
  const property = slotPaths(path)
    .map((candidate) => viewModelInstance.image(candidate))
    .find(Boolean);
  if (!property) return;
  const image = await fetchRiveImage(url);
  if (!isStale()) property.value = image;
  image.unref();
}
